/* eslint-disable max-len */
// This file is auto generated by before-build.js and will be overwritten with each build
export const AppVersion = JSON.parse("{\"flavor\":\"DEV\",\"gitHash\":\"48b175e\",\"appVersion\":\"1.1.0-dev.3\",\"buildTimestamp\":1784196637672}")
